import moment from 'moment';

export const formatNumber = (value: any, decimals = 2): string => {
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return num.toFixed(decimals);
};
export const formatInteger = (value: any) => value || value === 0 ? Number(value).toFixed(0) : '-';

export const formatCurrency = (value: any, prefix = '$', decimals = 2): string => {
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return `${prefix}${num.toFixed(decimals)}`;
};

export const formatDate = (value: any, format = 'DD/MM/YYYY'): string => {
  if (!value) return '-';
  return moment(value).format(format);
};

export const formatAbsolute = (value: any, decimals = 2): string => {
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return Math.abs(num).toFixed(decimals);
};

export const formatWithoutRounding = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return Number(value).toFixed(2);
};
